import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";

export default {
  namespaced: true,
  state: {
    customers: [],
    mycustomer: [],
    customer_history: [],
    total: null,
  },
  mutations: {
    SET_CUSTOMERS(state, data) {
      state.customers = data;
    },
    SET_CUSTOMER(state, data) {
      state.mycustomer = data;
    },
    SET_CUSTOMER_HISTORY(state, data) {
      state.customer_history = data;
    },
    REMOVE_INVOICE(state, id) {
      let invoiceIndex = state.customer_history.invoices.findIndex(
        (invoice) => invoice.id === id
      );
      state.customer_history.invoices.splice(invoiceIndex, 1);
    },
    REMOVE_ESTIMATE(state, id) {
      let estimateIndex = state.customer_history.estimates.findIndex(
        (estimate) => estimate.id === id
      );
      state.customer_history.estimates.splice(estimateIndex, 1);
    },
    REMOVE_EXPENSE(state, id) {
      let expenseIndex = state.customer_history.espenses.findIndex(
        (expense) => expense.id === id
      );
      state.customer_history.expenses.splice(expenseIndex, 1);
    },
    REMOVE_CUSTOMER(state, id) {
      let customerIndex = state.customers.data.findIndex(
        (customer) => customer.id === id
      );
      state.customers.data.splice(customerIndex, 1);
    },
    SET_TOTALPAGES(state, data) {
      state.total = data;
    },
  },
  actions: {
    async getCustomers({ commit }, params) {
      const headers = apiConfig().headers;
      let result = await API.get(ROUTES().customers, { params, headers })
        .then((res) => {
          commit("SET_CUSTOMERS", res.data);
          commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async getCustomer({ commit }, id) {
      let result = await API.get(`${ROUTES().customers}/${id}`, apiConfig())
        .then((res) => {
          commit("SET_CUSTOMER", res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });

      return result;
    },
    async getCustomerHistory({ commit }, id) {
      let result = await API.get(
        `${ROUTES().customers}/${id}/history`,
        apiConfig()
      )
        .then((res) => {
          commit("SET_CUSTOMER_HISTORY", res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });

      return result;
    },

    async addCustomer({}, payload) {
      let result = await API.post(ROUTES().customers, payload, apiConfig())
        .then((res) => {
          toast.success(`${res.data.message}`);
          router.push("/customers");
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async addCustomerFromEstimate({}, payload) {
      let result = await API.post(ROUTES().customers, payload, apiConfig())
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async editCustomer({}, { id, payload }) {
      let result = await API.put(
        `${ROUTES().customers}/${id}`,
        payload,
        apiConfig()
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
          router.push("/customers");
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async deleteCustomer({ commit }, id) {
      let result = API.delete(`${ROUTES().customers}/${id}`, apiConfig())
        .then((res) => {
          commit("REMOVE_CUSTOMER", id);
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    deleteInvoice({ commit }, id) {
      commit("REMOVE_INVOICE", id);
    },
    deleteEstimate({ commit }, id) {
      commit("REMOVE_ESTIMATE", id);
    },
    deleteExpense({ commit }, id) {
      commit("REMOVE_EXPENSE", id);
    },
  },
  getters: {
    customers(state) {
      return state.customers;
    },
    mycustomer(state) {
      return state.mycustomer;
    },
    customer_history(state) {
      return state.customer_history;
    },
    total(state) {
      return state.total;
    },
  },
};
